import {
  doDeleteRecord,
  loadrecent,
  loadstars
} from '../service/latest'
import {
  deleteFils, share
} from '../service/index'
import {
    deleteGroupsFile
} from '../service/common'
import {
  star,
  unstar
} from '../service/starred'
import {
  pageCount
} from '../../../src/config'
export default {
    namespaced: true,
    state(){
        return {
            fileList: [],
            fileids: [],
            initing: true,
            currentPage: 1,
            maxPage: false,
            doing: false,
            roamList: {},
            shareList: [],
            loading: false
        }
    },
    mutations: {
        INIT(state, paload){
            let noinit = paload && paload.noinit
            !noinit ? state.fileList = [] : ''
            state.fileids = []
            state.initing = !noinit
            state.currentPage = 1
            state.maxPage = false
            state.roamList = {}
            state.shareList = []
            state.loading = false
        },
        SAVE_RECENTS(state, {result,noinit}) {
            state.currentPage === 1 ? state.initing = false : null 
            state.maxPage = result.length < pageCount
            state.fileList = noinit && state.currentPage == 1 ? result : state.fileList.concat(result)
            state.currentPage += 1
        },
        UPDATE_LIST(state){  
            state.fileids = []
            state.roamList = {}
            state.shareList = []
        },
        CHECK_ITEM(state,{
            fileid,
            groupid,
            sid,
            shift
        }){
            let list = state.fileids
            let shareList = state.shareList
            let roamList = state.roamList
            
            let idx = list.indexOf(`${fileid}$$${sid}`)

            if (shift && list.length) {
                let uplist = []
                let downlist = []
                let flag = false
                state.fileList.map(item => {
                    item.fileid == fileid ? flag = true : ''
                    flag ? downlist.push(`${item.fileid}$$${item.sid}`) : uplist.push(`${item.fileid}$$${item.sid}`)
                })
                let originIdx = uplist.length
                let upIndex
                let downIndex
                uplist.map((item, i) => {
                    list.indexOf(item) > -1 && typeof upIndex === 'undefined' ? upIndex = i : ''
                })
                if (typeof upIndex == 'number') {
                    uplist.slice(upIndex).map((item,i) => {
                        let upidx = list.indexOf(item)
                        if (upidx < 0) {
                            let data = state.fileList[upIndex + i]
                            list.push(item)
                            data.sid ? shareList.push(data.sid) : ''
                            roamList[Number(item.split('$$')[0])] = data.groupid
                        }
                        if (list.indexOf(`${fileid}$$${sid}`) < 0) {
                            list.push(`${fileid}$$${sid}`)
                            sid ? shareList.push(sid) : ''
                            roamList[fileid] = groupid
                        }
                    })
                } else {
                    downlist.map((item, i) => {
                        list.indexOf(item) > -1 ? downIndex = i : ''
                    })
                    if (typeof downIndex == 'number') {
                        downlist.slice(0, downIndex).map((item,i) => {
                            let downidx = list.indexOf(item)
                            if (downidx < 0) {
                                let data = state.fileList[i + uplist.length + 1]
                                list.push(item)
                                data.sid ? shareList.push(data.sid) : ''
                                roamList[item] = data.groupid
                            }
                        })
                    }
                }
            }

            if (idx > -1 && !shift) {
                list.splice(idx, 1)
                sid ? shareList.splice(shareList.indexOf(sid), 1) : ''
                delete roamList[fileid]
            } else if(!shift) {
                list.push(`${fileid}$$${sid}`)
                sid ? shareList.push(sid) : ''
                roamList[fileid] = groupid
            }
            state.fileids = list
            state.roamList = roamList
            state.shareList = shareList
        },
        UPDATE_STAR(state, {
            fileid,
            type
          }) {
            type == 'star' ? 
            state.fileList.map(item => item.fileid == fileid ? item.stared = 1 : '') :
            state.fileList.map(item => item.fileid == fileid ? item.stared = 0 : '')
        },
        DOING(state,flag){
            state.doing = flag
        },
        LOADING(state, flag) {
            state.loading = flag
        }
    },
    actions: {
        flush({commit,dispatch}){
            commit('INIT',{noinit: true})
            dispatch('loadmore',{noinit: true})
        },
        deleteRecord({
            commit,
            state,
            dispatch
          }, {fileid,checked,groupid,sid}) {
            commit('DOING', true)
            let fileids = fileid ? [fileid] : []
            let ids = []
            let sids = sid ? [sid] : state.shareList
            let roamList = state.roamList
            state.fileids.length ? Object.keys(roamList).map(item => {
              ids.push({
                fileid: Number(item),
                groupid: roamList[item]
              })

              fileids.push(Number(item))
            }) : ''
            let cb = ({status,data}) => {
                if (status == 200) {
                    commit('UPDATE_LIST')
                    dispatch('close',null,{root: true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'DeleteSuc'
                    },{root:true})
                    dispatch('flush')
                }else{
                    commit('TOAST', {
                        type: 'error',
                        msg: data.result
                    },{root:true})
                }
                commit('DOING', false)
                
            }
            !checked ? 
            doDeleteRecord({
                fileids,
            }, cb) : state.fileids.length ? 
            deleteGroupsFile({ids},cb) : 
            deleteFils({
                fileids,
                groupid
            },cb)
        },
        loadmore({commit,state},paload){
            if (state.maxPage || state.loading) {
                return
            }
            commit('LOADING', true)
            let offset = (state.currentPage - 1 ) * pageCount
            let noinit = paload && paload.noinit
            loadrecent({
              count: pageCount,
              offset
            },({status,data}) => {
                if (status === 200) {
                    let result = data.roaminginfo
                    let sids = []
                    let fileids = []
                    result.map(item => {
                        item.sid ? sids.push(item.sid) : fileids.push(item.fileid)
                    })
                    if (fileids.length || sids.length) {
                        loadstars({fileids,sids},({status,data}) => {
                            if (status === 200) {
                                result.map(item => {
                                    data.ids.indexOf(Number(item.fileid)) > -1 || data.sids.indexOf(item.sid) > -1 ? item.stared = 1 : item.stared = 0
                                })
                                commit('SAVE_RECENTS', {
                                    result,
                                    noinit
                                })
                            }else{
                                commit('SAVE_RECENTS', {
                                    result,
                                    noinit
                                })
                                commit('TOAST', {
                                type: 'error',
                                msg: data.result
                                }, {
                                root: true
                                })
                            }
                            commit('LOADING', false)
                        })
                    }else {
                        commit('SAVE_RECENTS', {
                          result,
                          noinit
                        })
                        commit('LOADING', false)
                    }
                    
                }else{
                    commit('SAVE_RECENTS', {
                        result: []
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        },
        updateStar({commit,state,rootState},paload){
            commit('UPDATE_STAR',paload)
        },
        unstar({commit},fileid){
            // unstar({fileid},({status,data}) => {
            //     if (status === 200) {
            //       commit('SAVE_STAR', {...data,fileid})
            //     } else {
            //       commit('TOAST', {
            //         type: 'error',
            //         msg: data.result
            //       }, {
            //         root: true
            //       })
            //     }
            // })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/latest.js